export const queryKeys = {
  teamMember: "teamMember",
  dataList: "dataList",
  listCategories: "listCategories",
  listServices: "listServices",
  uncategorizedServices: "uncategorizedServices",
  treatmentTypes: "treatmentTypes",
  listLocations: "listLocations",
  listTaxes: "listTaxes",
  listTeamMember: "listTeamMember",
  listPackages: "listPackages",
  listPackagesCategories: "listPackagesCategories",
  totalCost: "totalCost",
  // clients
  listClient: "listClient",
  listTeamsOnboarind: "listClient",
  listServicesOnboarind: "listClient",
  listSalon: "listSalon",
  reviewsList: "reviewsList",
  listSales: "listSales",
  listOrderSales: "listOrderSales",
  listServicesSales: "listOrderSales",
  listMembershipsSales: "listOrderSales",
  listProductsSales: "listOrderSales",
  listGiftCardSales: "listGiftCardSales",
  listClosedPeriods: "listClosedPeriods",
  showTeamMember: "showTeamMember",
  listSpacficTeamMemer: "listSpacficTeamMemer",
  listParentwithServices: "listParentwithServices",
  timeOffs: "timeOffs",
  reports: "reports",
  overview: "overview",
  workingHours: "workingHours",
  timeOffTypes: "timeOffTypes",
  listCommission: "listCommission",
  listProduct: "listProduct",
  listProductCategories: "listProductCategories",
  listBrands: "listBrands",
  listGiftCards: "listGiftCards",
  listMemberships: "listMemberships",
  listSuppliers: "listSuppliers",
  listVoucherDurations: "listVoucherDurations",
  listTaxesAndGroup: "listTaxesAndGroup",
  Locations: "locations",
  locationLinksData: "locationLinksData",
  suppliers: "suppliers",
  promoCodes: "promoCodes",
};
